var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCallScreenshareOffi = function SvgCallScreenshareOffi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M21.973 4.856q.026.15.026.306v10.54a1.8 1.8 0 0 1-1.8 1.8h-7.37v1.536h2.646a.8.8 0 0 1 0 1.6H8.58a.8.8 0 0 1 0-1.6h2.647v-1.536H9.326l1.6-1.6H20.2a.2.2 0 0 0 .2-.2V6.43l1.574-1.574zM17.8 3.362l-1.6 1.6H3.856a.2.2 0 0 0-.2.2v10.54a.2.2 0 0 0 .2.2H5.27l-1.592 1.592a1.8 1.8 0 0 1-1.622-1.792V5.162a1.8 1.8 0 0 1 1.8-1.8z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e91e63",
    d: "M5.97 19.161 21.763 3.368a.801.801 0 0 0-1.132-1.131L4.838 18.03A.801.801 0 0 0 5.97 19.16"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCallScreenshareOffi);
export default ForwardRef;